<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/AdminReport/JobIssue'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJIAgentCodes'"
                    :name="'reJIAgentCodes'"
                    :select2-options="reJIAgentCodesOptions"
                    v-model="reJIAgentCodes"
                    ref="reJIAgentCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reJIAgentCodes"
                    :multiple="true"
                    :options="reJIAgentCodesOptions"
                    v-on:open="LoadreJIAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJIDepartments'"
                    :name="'reJIDepartments'"
                    :select2-options="reJIDepartmentsOptions"
                    multiple
                    v-model="reJIDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reJIDepartments"
                    :multiple="true"
                    :options="reJIDepartmentsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJIStatus'"
                    :name="'reJIStatus'"
                    :select2-options="reJIStatusOptions"
                    v-model="reJIStatus"
                    multiple
                    ref="reJIStatusSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJIStatus"
                    :multiple="true"
                    :options="reJIStatusOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันทีเปิดใบงาน(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJIDateStart"
                      name="reJIDateStart"
                      ref="reJIDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันทีเปิดใบงาน(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJIDateEnd"
                      name="reJIDateEnd"
                      ref="reJIDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้แจ้งปัญหา:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJICreatedUser'"
                    :name="'reJICreatedUser'"
                    :select2-options="reJICreatedUserOptions"
                    multiple
                    v-model="reJICreatedUser"
                  ></select2> -->
                  <treeselect
                    v-model="reJICreatedUser"
                    :multiple="true"
                    :options="reJICreatedUserOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ปิดใบงาน:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJICloseUser'"
                    :name="'reJICloseUser'"
                    :select2-options="reJICloseUserOptions"
                    multiple
                    v-model="reJICloseUser"
                  ></select2> -->
                  <treeselect
                    v-model="reJICloseUser"
                    :multiple="true"
                    :options="reJICloseUserOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="JobIssueTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="20">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">เลขที่ใบแจ้งปัญหา</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">รายละเอียดปัญหา</th>
                    <th class="all text-center">สถานะของใบงาน</th>
                    <th class="all text-center">ผู้แจ้งปัญหา</th>
                    <th class="all text-center">ผู้ปิดใบงาน</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reJIDepartments: [],
      reJIAgentCodes: [],
      reMachineType: [],
      reBarbutlerType: [],
      reBarcodeMachine: null,
      reBarcodeBarbutler: null,
      reJIStatus: [],
      reJICloseUser: [],
      reJICreatedUser: [],
      reJIDateStart: null,
      reJIDateStart: null,
      reJICreatedUserOptions: [],
      // reJICreatedUserOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้แจ้งปัญหา",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/JobIssue/CreatedUserOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJICloseUserOptions: [],
      // reJICloseUserOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้ปิดใบงาน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/JobIssue/CloseUserOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJIDepartmentsOptions: [],
      // reJIDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJIAgentCodesOptions: [],
      // reJIAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reShopTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reJIStatusOptions: [],
      // reJIStatusOptions: [
      //   { id: "JOB_STATUS_WAITING", label: "รอดำเนินการ" },
      //   { id: "JOB_STATUS_SUCCESS", label: "ดำเนินการเรียบร้อย" },
      //   { id: "JOB_STATUS_PENDING", label: "ระหว่างดำเนินการ" },
      //   { id: "JOB_STATUS_CANCEL", label: "ยกเลิก" },
      // ],
      reProductBrandIdOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "Singha", text: "Singha", data: null },
          { id: "Leo", text: "Leo", data: null },
          { id: "Carlsberg", text: "Carlsberg", data: null },
          { id: "Asahi", text: "Asahi", data: null },
          { id: "Kronenbourg", text: "Kronenbourg", data: null },
          { id: "Snowy", text: "Snowy", data: null },
        ],
      },
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reMachineTypeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2MachineType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reBarbutlerTypeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2BarButlerType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reJIDepartments = [];
      self.reJIAgentCodes = [];
      self.reJIStatus = [];
      self.reJIDateStart = null;
      self.reJIDateEnd = null;
      self.reJICreatedUser = [];
      self.reJICloseUser = [];

      $("#reJIDepartments")
        .val("")
        .trigger("change");

      $("#reJIAgentCodes")
        .val("")
        .trigger("change");

      $("#reJIStatus")
        .val("")
        .trigger("change");

      $("#reJICreatedUser")
        .val("")
        .trigger("change");

      $("#reJICloseUser")
        .val("")
        .trigger("change");

      $("#reJIDateStart")
        .val("")
        .trigger("change");

      $("#reJIDateEnd")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#JobIssueTable").DataTable();
      table.draw();
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportJobIssue",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reJIAgentCodes,
          Region: self.reJIDepartments,
          JobStatusCode: self.reJIStatus,
          CreateDateStart:
            self.reJIDateStart != null
              ? self.reJIDateStart.format("DD/MM/YYYY")
              : null,
          CreateDateEnd:
            self.reJIDateEnd != null
              ? self.reJIDateEnd.format("DD/MM/YYYY")
              : null,
          UserCreate: self.reJICreatedUser,
          UserClose: self.reJICloseUser,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreJICreatedUserOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/JobIssue/CreatedUserOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJICreatedUserOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJICloseUserOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/JobIssue/CloseUserOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJICloseUserOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJIDepartmentsOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reJIDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJIDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJIAgentCodesOptions: function(e) {
      var self = this;
      self.reJIAgentCodesOptions = [{ id : "", label : "Loading...", isDisabled: true}]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.reJIDepartments,
            AgentCodes: [],
            page: 1,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.reJIAgentCodesOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reJIAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJIStatusOptions: function(e) {
      var self = this;
      var data = [
        { id: "JOB_STATUS_WAITING", label: "รอดำเนินการ" },
        { id: "JOB_STATUS_SUCCESS", label: "ดำเนินการเรียบร้อย" },
        { id: "JOB_STATUS_PENDING", label: "ระหว่างดำเนินการ" },
        { id: "JOB_STATUS_CANCEL", label: "ยกเลิก" },
      ];
      data.forEach((element) => {
        self.reJIStatusOptions.push({
          id: element.id,
          label: element.label,
        });
      });
    },
  },
  async mounted() {
    let self = this;

    self.LoadreJICreatedUserOptions();
    self.LoadreJICloseUserOptions();
    self.LoadreJIDepartmentsOptions();
    self.LoadreJIAgentCodesOptions();
    self.LoadreJIStatusOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reJIDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reJIDateStart = moment().set("date",1);
    $(self.$refs.reJIDateStart)
      .datepicker(
        "update",
        !!self.reJIDateStart ? self.reJIDateStart.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        //self.reJIDateStart = moment(e.date);
        self.reJIDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reJIDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reJIDateEnd = moment().endOf('month');
    $(self.$refs.reJIDateEnd)
      .datepicker(
        "update",
        !!self.reJIDateEnd ? self.reJIDateEnd.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        //self.reJIDateEnd = moment(e.date);
        self.reJIDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#JobIssueTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Report/JobIssue",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            AgentCode: self.reJIAgentCodes,
            Region: self.reJIDepartments,
            JobStatusCode: self.reJIStatus,
            CreateDateStart:
              self.reJIDateStart != null
                ? self.reJIDateStart.format("DD/MM/YYYY")
                : null,
            CreateDateEnd:
              self.reJIDateEnd != null
                ? self.reJIDateEnd.format("DD/MM/YYYY")
                : null,
            UserCreate: self.reJICreatedUser,
            UserClose: self.reJICloseUser,
            IsInitial: self.reAaIsInitial,
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[0, "desc"]],
      columns: [
        // { data: "createdDateString", className: "text-center" },
        {
          data: "createdDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.createdDateString;
          },
        },
        { data: "jobNumber", className: "text-center" },
        { data: "agentName", className: "text-center" },
        { data: "region", className: "text-center" },
        { data: "shopCode", className: "text-center" },
        { data: "customeR_NAME", className: "text-center" },
        { data: "namE2", className: "text-center" },
        { data: "detail", className: "text-center" },
        { data: "jobStatusName", className: "text-center" },
        { data: "createdUser", className: "text-center" },
        { data: "closedUserName", className: "text-center" },
      ],
      drawCallback: function(settings) {
        self.reAaIsInitial = false;
        self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
      },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/AdminReport/JobIssue.vue